import { UntypedFormControl, AsyncValidator, AsyncValidatorFn, ValidationErrors, ValidatorFn, AbstractControl, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';

/**
 * Required validator
 */
export class RequiredValidator {
  /**
   * constructor to inject dependency
   */
  constructor() {}

  /**
   * default angular required validators does consider spaces inputted as value and does not triggered required validators
   * so this validation will trim the values and trigger required validation if empty
   * @param ctrl control to check for required
   */
  static validateRequired(ctrl: UntypedFormControl): ValidationErrors {
    const ctrlValue = ctrl.value as string;

    return ctrlValue && ctrlValue.trim().length === 0 ? { required: true } : null;
  }

  /**
   * if one field is entered, the fields in the fieldsarray will be set to required
   * @param fields array of fields
   */
  static relatedFieldRequired(...fields): ValidatorFn {
    return (ac: AbstractControl) => {
      let isValueEntered = false;
      let isAnyCtrlEmpty = false;

      for (const field of fields) {
        const ctrl = ac.get(field);
        if (ctrl) {
          RequiredValidator.clearErrors(ctrl);
          const ctrlValue = ctrl.value;
          if (ctrlValue !== '' && ctrlValue !== null) {
            isValueEntered = true;
          }
        }
      }
      if (isValueEntered) {
        for (const field of fields) {
          const ctrl = ac.get(field);
          if (ctrl.value !== '' && ctrl.value !== null) {
            RequiredValidator.clearErrors(ctrl);
          } else {
            isAnyCtrlEmpty = true;
            ctrl.setErrors({ required: true });
          }
        }
      }
      return isAnyCtrlEmpty ? { isRequired: true } : null;
    };
  }

  /**
   * clear the errors
   * @param ctrl control
   */
  private static clearErrors(ctrl: AbstractControl) {
    if (ctrl.errors && ctrl.errors.required) {
      delete ctrl.errors.required;
    }
    if (ctrl.errors && Object.keys(ctrl.errors).length === 0) {
      ctrl.setErrors(null);
    }
  }
}
